import { DateTime } from 'luxon';
import { ISOString } from '@/types/date-types';
import removeTzFromIsoDate from '@/modules/people/composables/remove-tz-from-iso-date';

export function fromJSDateToISOString(
  date: Date | null | undefined
): ISOString | null {
  if (!date) {
    return null;
  }
  return DateTime.fromJSDate(date).toISODate() as ISOString;
}

export function fromISOToJSDate(date: Date | ISOString): Date | null {
  if (!date) {
    return null;
  }

  if (date instanceof Date) {
    return date;
  }

  return DateTime.fromISO(removeTzFromIsoDate(date)).toJSDate();
}
